type PropTypes = {
  className?: string
};

const ExportIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="16"
        height="16"
        fill="white"
        fillOpacity={0.01}
        style={{ mixBlendMode: 'multiply' }}
      />
      <path d="M15 12.4999L14.293 11.7929L13 13.0859V8.99993H12V13.0859L10.707 11.7929L10 12.4999L12.5 14.9999L15 12.4999Z" fill="currentColor" />
      <path d="M9 13.9999H4V1.99993H8V4.99993C8.00077 5.26491 8.10637 5.51882 8.29374 5.70619C8.48111 5.89356 8.73502 5.99916 9 5.99993H12V7.49993H13V4.99993C13.0018 4.93421 12.9893 4.86889 12.9634 4.80847C12.9375 4.74804 12.8988 4.69395 12.85 4.64993L9.35 1.14993C9.30599 1.10109 9.2519 1.06239 9.19147 1.03649C9.13104 1.01059 9.06572 0.99812 9 0.999928H4C3.73502 1.00069 3.48111 1.1063 3.29374 1.29367C3.10637 1.48104 3.00077 1.73495 3 1.99993V13.9999C3.00077 14.2649 3.10637 14.5188 3.29374 14.7062C3.48111 14.8936 3.73502 14.9992 4 14.9999H9V13.9999ZM9 2.19993L11.8 4.99993H9V2.19993Z" fill="currentColor" />
    </svg>
  )
}

export default ExportIcon
